export const LOGIN_TITLE_1 = "Sri Badrika Ashram";
export const LOGIN_TITLE_2 = "Streaming Site";
export const LOGIN_BUTTON = "Sign in";
export const EMAIL_LABEL = "Email Address";
export const PASSWORD_LABEL = "Password";
export const RESET_PASSWORD_LABEL = "Reset Password";
export const APP_TITLE = "Sri Badrika Ashram Streaming Site";
export const LOGOUT_BUTTON = "Logout";



// WEBPACK FOOTER //
// ./src/constants/labels.js